<template>
    <div class="filters">
        <div class="card">
            <div class="card-header">
                <h3 class="card-title">Liste des produits</h3>
                <div class="toggle-filters ml-3">
                    <el-switch v-model="viewAllFilters" active-text="Afficher les filtres"
                               inactive-text="Masquer les filtres"></el-switch>
                </div>

                <div class="card-options">
                    <!--<el-dropdown v-if="user.can('catalogue export')" class="mr-2">
                        <el-button type="secondary">
                            Rechercher par fichier<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="displayDialogSearch('ref')">Ref</el-dropdown-item>
                            <el-dropdown-item @click.native="displayDialogSearch('base_ref')">Base Ref</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>-->

                    <el-dropdown v-if="user.can('catalogue export')">
                        <el-button type="primary">
                            Export<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="exportProducts('normal')">Normal</el-dropdown-item>
                            <el-dropdown-item @click.native="exportProducts('update')">Pour mise à jours
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="exportProducts('prices')">Pour prix</el-dropdown-item>
                            <el-dropdown-item @click.native="exportProducts('ean13')">Pour code barre/ref fab
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="exportProducts('coef')">Pour coef fournisseur
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="exportProducts('mandatory_features')">Features absentes
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="exportProducts('logistics')">Logistique</el-dropdown-item>
                            <el-dropdown-item @click.native="exportProducts('accessories')">Produits Recommandés
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="exportProducts('dispos')">Date de dispos</el-dropdown-item>
                            <el-dropdown-item @click.native="exportProducts('videos')">Vidéos</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown v-if="user.can('catalogue importer')" class="ml-2">
                        <el-button type="secondary">
                            Import<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="displayDialogImport()">Fichier mise à jour
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="displayDialogImportImages()">Photos</el-dropdown-item>
                            <el-dropdown-item v-if="user.can('catalogue importer spin')"
                                              @click.native="displayDialogSpin('open')">Importer Spin
                            </el-dropdown-item>
                            <el-dropdown-item v-if="user.can('catalogue importer')"
                                              @click.native="displayDialogPrices()">Import prix
                            </el-dropdown-item>
                            <el-dropdown-item v-if="user.can('catalogue importer')" @click.native="displayDialogEan()">
                                Import code barre/ref fab
                            </el-dropdown-item>
                            <el-dropdown-item v-if="user.can('catalogue importer')" @click.native="displayDialogCoef()">
                                Import coef fournisseur
                            </el-dropdown-item>
                            <el-dropdown-item v-if="user.can('catalogue importer')"
                                              @click.native="displayDialogLogistics()">Import logistique
                            </el-dropdown-item>
                            <el-dropdown-item v-if="user.can('catalogue importer')"
                                              @click.native="displayDialogAccessories()">Import produits recommandéœs
                            </el-dropdown-item>
                            <el-dropdown-item v-if="user.can('catalogue importer')"
                                              @click.native="displayDialogDatesDispos()">Import dates dispos
                            </el-dropdown-item>
                            <el-dropdown-item v-if="user.can('catalogue importer')"
                                              @click.native="displayDialogVideos()">Import videos
                            </el-dropdown-item>
                            <el-dropdown-item v-if="user.can('catalogue importer')" @click.native="displayDialogVideos()">Import videos</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                    <a v-if="user.can('create product')" class="btn btn-secondary btn-sm ml-2" href="#"
                       @click="createProduct()">Nouveau produit</a>
                </div>
            </div>
            <el-form ref="filtersForm" :model="filters" label-position="top">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <el-form-item label="Marques" prop="brand_id">
                                <el-cascader
                                    v-model="filters.brand_id"
                                    :filter-method="filterCascader"
                                    :options="brandsOptions"
                                    :props="{label: 'name', value: 'id', multiple: true, checkStrictly: true}"
                                    class="full-width"
                                    clearable
                                    filterable
                                    multiple
                                    @change="handleChangeFilter"
                                ></el-cascader>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">
                            <el-form-item label="Fournisseurs" prop="manufacturer_id">
                                <el-cascader
                                    v-model="filters.manufacturer_id"
                                    :filter-method="filterCascader"
                                    :options="manufacturersOptions"
                                    :props="{label: 'name', value: 'id', multiple: true, checkStrictly: true}"
                                    class="full-width"
                                    clearable
                                    filterable
                                    multiple
                                    @change="handleChangeFilter"
                                ></el-cascader>
                            </el-form-item>
                        </div>
                        <div v-if="!duplicateMode" class="col-md-2">
                            <el-form-item label="Catégories" prop="category_id">
                                <el-cascader
                                    ref="cascader"
                                    v-model="filters.category_id"
                                    :filter-method="filterCascader"
                                    :options="categoriesOptions"
                                    :props="{label: 'name', value: 'id', multiple: true }"
                                    change-on-select
                                    clearable
                                    filterable
                                    multiple
                                    placeholder="Catégorie"
                                    @change="handleChangeFilter"
                                ></el-cascader>
                            </el-form-item>
                        </div>
                        <div v-if="!duplicateMode" class="col-md-2">
                            <el-form-item label="Catégories Exclues" prop="category_exclude_id">
                                <el-cascader
                                    ref="cascader"
                                    v-model="filters.category_exclude_id"
                                    :filter-method="filterCascader"
                                    :options="categoriesOptions"
                                    :props="{label: 'name', value: 'id', multiple: true }"
                                    change-on-select
                                    clearable
                                    filterable
                                    multiple
                                    placeholder="Catégorie Exclues"
                                    @change="handleChangeFilter"
                                ></el-cascader>
                            </el-form-item>
                        </div>
                        <div v-loading="loaderProductTypeOptions" class="col-md-2">
                            <el-form-item label="Type" prop="productType">
                                <el-cascader
                                    v-model="filters.productType"
                                    :filter-method="filterCascader"
                                    :options="productTypeOptions"
                                    :props="{label: 'value', value: 'id', multiple: true, checkStrictly: true}"
                                    class="full-width"
                                    clearable
                                    filterable
                                    multiple
                                    @change="handleChangeFilter"
                                ></el-cascader>
                            </el-form-item>
                        </div>
                        <div v-loading="loaderSizes" class="col-md-2">
                            <el-form-item label="Tailles" prop="sizes">
                                <el-cascader
                                    v-model="filters.sizes"
                                    :filter-method="filterCascader"
                                    :options="sizesOptions"
                                    :props="{label: 'value', value: 'value', multiple: true, checkStrictly: true}"
                                    class="full-width"
                                    clearable
                                    filterable
                                    multiple
                                    @change="handleChangeFilter"
                                ></el-cascader>
                            </el-form-item>
                        </div>
                        <div v-loading="loaderFeatures" class="col-md-2">
                            <el-form-item label="Features" prop="features">
                                <el-cascader
                                    v-model="filters.features"
                                    :filter-method="filterCascader"
                                    :options="featuresOptions"
                                    :props="{label: 'label', value: 'value', multiple: true, checkStrictly: true}"
                                    class="full-width"
                                    clearable
                                    filterable
                                    multiple
                                    @change="handleChangeFilter"
                                ></el-cascader>
                            </el-form-item>
                        </div>
                        <div v-loading="loaderFeatures" class="col-md-2">
                            <el-form-item label="Features Exclues" prop="features_exclude">
                                <el-cascader
                                    v-model="filters.features_exclude"
                                    :filter-method="filterCascader"
                                    :options="featuresOptions"
                                    :props="{label: 'label', value: 'value', multiple: true, checkStrictly: true}"
                                    class="full-width"
                                    clearable
                                    filterable
                                    multiple
                                    @change="handleChangeFilter"
                                ></el-cascader>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">
                            <el-form-item label="Prefixe" prop="mf_prefixe">
                                <el-select v-model="filters.mf_prefixe" allow-create clearable
                                           filterable placeholder="Prefixe" @change="handleChangeFilter">
                                    <el-option v-for="item in prefixesOptions" :key="item.value" :label="item.name"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">
                            <el-form-item label="Référencement Speedway" prop="referencement_speedway">
                                <el-select v-model="filters.referencement_speedway" clearable
                                           filterable multiple
                                           placeholder="Référencement Speedway" @change="handleChangeFilter">
                                    <el-option v-for="item in referencementSpeedwayOptions" :key="item.value"
                                               :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">
                            <el-form-item label="Statut Syncro" prop="syncPutStatus">
                                <el-radio-group v-model="filters.syncPutStatus" @change="handleChangeFilter">
                                    <el-radio-button :label="true">En cours</el-radio-button>
                                    <el-radio-button :label="null">Désactivé</el-radio-button>
                                    <el-radio-button :label="false">Echoué</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <!--el-form-item prop="syncError" label="Erreur synchro">
                                <el-select @change="handleChangeFilter" clearable v-model="filters.syncError" placeholder="Type d'erreur synchro" filterable allow-create>
                                    <el-option label="all" value="all">
                                    </el-option>
                                    <el-option v-for="item in syncErrorOptions" :key="item" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>-->
                        </div>
                        <div class="col-md-2">
                            <el-form-item label="Crée depuis" prop="created_at">
                                <el-date-picker v-model="filters.created_at" :picker-options="pickerCreatedAt"
                                                placeholder="Choississez un jour" type="date"
                                                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="col-md-1">
                            <el-form-item v-if="!duplicateMode" label="Prix" prop="priceValue">
                                <el-input v-model="filters.priceValue[0]" placeholder="bas"></el-input>
                                <el-input v-model="filters.priceValue[1]" placeholder="haut"></el-input>
                            </el-form-item>
                        </div>
                        <div class="col-md-1">
                            <el-form-item v-if="!duplicateMode" label="Marge" prop="margeValue">
                                <el-input v-model="filters.margeValue[0]" placeholder="bas"></el-input>
                                <el-input v-model="filters.margeValue[1]" placeholder="haut"></el-input>
                            </el-form-item>
                        </div>
                        <template v-if="viewAllFilters">
                            <div class="col-md-12">
                                <el-form-item v-if="!duplicateMode" label="vidéos" prop="hasVideo">
                                    <el-radio-group v-model="filters.hasVideo" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Sans</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Avec</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="!duplicateMode" label="photos" prop="hasMedias">
                                    <el-radio-group v-model="filters.hasMedias" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Sans</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Avec</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item prop="hasMedias" label="photos" v-if="!duplicateMode">
                                    <el-radio-group @change="handleChangeFilter" :size="sizeToggleFilter" v-model="filters.hasMedias">
                                        <el-radio-button :label="false">Sans</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Avec</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="!duplicateMode" label="Prix d'achat HT" prop="hasPaht">
                                    <el-radio-group v-model="filters.hasPaht" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Sans</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Avec</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="!duplicateMode" label="Repricing" prop="hasNewPrice">
                                    <el-radio-group v-model="filters.hasNewPrice" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Sans</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Avec</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="!duplicateMode" label="Description" prop="hasDesc">
                                    <el-radio-group v-model="filters.hasDesc" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Sans</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Avec</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="!duplicateMode" label="Code barre" prop="hasEan13">
                                    <el-radio-group v-model="filters.hasEan13" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Sans</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Avec</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="!duplicateMode" label="SEO / Desc" prop="hasSeo">
                                    <el-radio-group v-model="filters.hasSeo" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Sans</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Avec</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="!duplicateMode" label="Activé" prop="activated">
                                    <el-radio-group v-model="filters.activated" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Non</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Oui</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="!duplicateMode" label="Activé (Presta)" prop="presta_activated">
                                    <el-radio-group v-model="filters.presta_activated" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Non</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Oui</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="!duplicateMode" label="Stock" prop="stock">
                                    <el-radio-group v-model="filters.stock" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Sans</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Avec</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="!duplicateMode" label="Stock (Speedway)" prop="presta_stock">
                                    <el-radio-group v-model="filters.presta_stock" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Sans</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Avec</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="!duplicateMode" label="Gestion du stock ?" prop="sync_stock">
                                    <el-radio-group v-model="filters.sync_stock" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Sans</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Avec</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                            <div class="col-md-12">
                                <el-form-item v-if="!duplicateMode" label="Variation incompléte ?"
                                              prop="variationUndefined">
                                    <el-radio-group v-model="filters.variationUndefined" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Non</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Oui</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="view == 'normal'" label="Référence en double ?" prop="duplicate">
                                    <el-radio-group v-model="filters.duplicate" :size="sizeToggleFilter"
                                                    @change="handleDuplicateRef">
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Oui</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="view == 'normal'" label="Shop ID en double ?"
                                              prop="duplicateShopId">
                                    <el-radio-group v-model="filters.duplicateShopId" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Oui</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="Hybride ?" prop="isHybrid">
                                    <el-radio-group v-model="filters.isHybrid" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Non</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Oui</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="Syncro ?" prop="isSync">
                                    <el-radio-group v-model="filters.isSync" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Non</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Oui</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="Variation avec shopId ?" prop="variationShopId">
                                    <el-radio-group v-model="filters.variationShopId" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Non</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Oui</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item v-if="user.can('remove product')" label="Supprimés ?" prop="deleted">
                                    <el-radio-group v-model="filters.deleted" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Non</el-radio-button>
                                        <el-radio-button :label="true">Oui</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="Date fournisseur ?" prop="hasDateDisposFourn">
                                    <el-radio-group v-model="filters.hasDateDisposFourn" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Non</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Oui</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="Prix à zero ?" prop="hasPrice">
                                    <el-radio-group v-model="filters.hasPrice" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="true">Non</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="false">Oui</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="Produits Recommandés ?" prop="hasAccessories">
                                    <el-radio-group v-model="filters.hasAccessories" :size="sizeToggleFilter"
                                                    @change="handleChangeFilter">
                                        <el-radio-button :label="false">Non</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Oui</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                            <div class="col-md-2">
                                <el-form-item label="Liste de pim id" prop="ids">
                                    <el-input v-model="filters.ids" clearable
                                              placeholder="Rechercher des produits par pim ids"
                                              type="textarea" @change="handleChangeFilter" />
                                </el-form-item>
                            </div>
                            <div class="col-md-2">
                                <el-form-item label="Liste de shop ids" prop="shop_ids">
                                    <el-input v-model="filters.shop_ids" clearable
                                              placeholder="Rechercher des produits par shop id"
                                              type="textarea"
                                              @change="handleChangeFilter" />
                                </el-form-item>
                            </div>
                            <div class="col-md-4">
                                <el-form-item label="Liste de base ref" prop="base_refs">
                                    <el-input v-model="filters.base_refs" clearable
                                              placeholder="Rechercher des produits par base ref"
                                              type="textarea"
                                              @change="handleChangeFilter" />
                                </el-form-item>
                            </div>
                            <div class="col-md-2">
                                <el-form-item label="Liste de ref fournisseur" prop="external_refs">
                                    <el-input v-model="filters.external_refs" clearable
                                              placeholder="Rechercher des produits par ref fournisseur"
                                              type="textarea"
                                              @change="handleChangeFilter" />
                                </el-form-item>
                            </div>
                            <div class="col-md-2">
                                <el-form-item label="Liste de codes barres" prop="ean13s">
                                    <el-input v-model="filters.ean13s" clearable
                                              placeholder="Rechercher des produits par code barre"
                                              type="textarea"
                                              @change="handleChangeFilter" />
                                </el-form-item>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="card-footer">
                    <div v-if="user.can('actions groupes')" class="pull-left">
                        <el-dropdown split-button @command="applyAction">
                            Actions groupées
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="(item, index) in groupedActionsOptions" :key="index"
                                                  :command="item.value">{{ item.label }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-checkbox v-model="applyToAllResult">Appliquer à tous les résultats</el-checkbox>

                    </div>
                    <div class="pull-right">
                        <el-button plain type="info" @click="resetFilters">Annuler</el-button>
                        <el-button type="primary" @click="validFilters">Valider</el-button>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </el-form>
        </div>
        <el-dialog v-loading="dialogSpin.loader" :fullscreen="true" :visible.sync="dialogSpin.display"
                   title="Import Spin"
                   @close="closeDialogSpin">
            <el-upload ref="uploadSpin" :headers="dialogSpin.headersUpload" :on-progress="spinUploadStart"
                       :on-success="spinUploaded" action="/products/spin">
                <el-button slot="trigger" size="small" type="primary">Choisir un fichier</el-button>
            </el-upload>
            <el-table
                :data="dialogSpin.currentRows"
                style="width: 100%">
                <el-table-column
                    label="ID"
                    prop="ID"
                    width="180">
                </el-table-column>
                <el-table-column
                    label="Shop ID"
                    prop="Shop ID"
                    width="180">
                </el-table-column>
                <el-table-column
                    label="Titre"
                    prop="Titre"
                >
                </el-table-column>
                <el-table-column
                    label="Description"
                    prop="Description"
                >
                </el-table-column>
            </el-table>
            <el-pagination
                :current-page="dialogSpin.currentPage"
                :page-size="dialogSpin.pageSize"
                :total="dialogSpin.total"
                layout="prev, pager, next"
                @current-change="pageSpinChange"
            >
            </el-pagination>

            <span slot="footer" class="dialog-footer">
                <el-button v-if="!dialogSpin.processing" @click="displayDialogSpin('close')">Annuler</el-button>
                <el-button v-if="dialogSpin.ended" @click="displayDialogSpin('close')">Fermer</el-button>
                <el-button v-if="!dialogSpin.processing" type="primary"
                           @click="displayDialogSpin('process')">Confirmer</el-button>
            </span>
        </el-dialog>
        <el-dialog v-loading="dialogImport.loader" :fullscreen="true" :visible.sync="dialogImport.display"
                   title="Import fichier mise à jour" @close="closeDialogImport">
            <el-upload ref="uploadImport" :headers="dialogImport.headersUpload" :on-progress="importUploadStart"
                       :on-success="importUploaded" action="/products/import">
                <el-button slot="trigger" size="small" type="primary">Choisir un fichier</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!dialogImport.processing" @click="closeDialogImport()">Annuler</el-button>
                <el-button v-if="dialogImport.ended" @click="closeDialogImport()">Fermer</el-button>
                <el-button v-if="!dialogImport.processing" type="primary"
                           @click="closeDialogImport()">Confirmer</el-button>
            </span>
        </el-dialog>
        <el-dialog v-loading="dialogPrices.loader" :fullscreen="true" :visible.sync="dialogPrices.display"
                   title="Import prix" @close="closeDialogPrices">
            <el-upload ref="uploadPrices" :headers="dialogPrices.headersUpload" :on-progress="pricesUploadStart"
                       :on-success="pricesUploaded" action="/products/import/prices">
                <el-button slot="trigger" size="small" type="primary">Choisir un fichier</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!dialogPrices.processing" @click="closeDialogPrices()">Annuler</el-button>
                <el-button v-if="dialogPrices.ended" @click="closeDialogPrices()">Fermer</el-button>
                <el-button v-if="!dialogPrices.processing" type="primary"
                           @click="closeDialogPrices()">Confirmer</el-button>
            </span>
        </el-dialog>
        <el-dialog v-loading="dialogEan.loader" :fullscreen="true" :visible.sync="dialogEan.display"
                   title="Import code barre/ref fab" @close="closeDialogEan">
            <el-upload ref="uploadEan" :headers="dialogEan.headersUpload" :on-progress="eanUploadStart"
                       :on-success="eanUploaded" action="/products/import/ean13">
                <el-button slot="trigger" size="small" type="primary">Choisir un fichier</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!dialogEan.processing" @click="closeDialogEan()">Annuler</el-button>
                <el-button v-if="dialogEan.ended" @click="closeDialogEan()">Fermer</el-button>
                <el-button v-if="!dialogEan.processing" type="primary" @click="closeDialogEan()">Confirmer</el-button>
            </span>
        </el-dialog>
        <el-dialog v-loading="dialogDatesDispos.loader" :fullscreen="true" :visible.sync="dialogDatesDispos.display"
                   title="Import dates dispos" @close="closeDialogDatesDispos">
            <el-upload ref="uploadDatesDispos" :headers="dialogDatesDispos.headersUpload"
                       :on-progress="datesDisposUploadStart"
                       :on-success="datesDisposUploaded" action="/products/import/dates-dispos">
                <el-button slot="trigger" size="small" type="primary">Choisir un fichier</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!dialogDatesDispos.processing" @click="closeDialogDatesDispos()">Annuler</el-button>
                <el-button v-if="dialogDatesDispos.ended" @click="closeDialogDatesDispos()">Fermer</el-button>
                <el-button v-if="!dialogDatesDispos.processing" type="primary" @click="closeDialogDatesDispos()">Confirmer</el-button>
            </span>
        </el-dialog>
        <el-dialog v-loading="dialogCoef.loader" :fullscreen="true" :visible.sync="dialogCoef.display"
                   title="Import coef fournisseur" @close="closeDialogEan">
            <el-upload ref="uploadCoef" :headers="dialogCoef.headersUpload" :on-progress="coefUploadStart"
                       :on-success="coefUploaded" action="/products/import/coef">
                <el-button slot="trigger" size="small" type="primary">Choisir un fichier</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!dialogCoef.processing" @click="closeDialogCoef()">Annuler</el-button>
                <el-button v-if="dialogCoef.ended" @click="closeDialogCoef()">Fermer</el-button>
                <el-button v-if="!dialogCoef.processing" type="primary" @click="closeDialogCoef()">Confirmer</el-button>
            </span>
        </el-dialog>
        <el-dialog v-loading="dialogLogistics.loader" :fullscreen="true" :visible.sync="dialogLogistics.display"
                   title="Import logistics" @close="closeDialogLogistics">
            <el-upload ref="uploadLogistics" :headers="dialogLogistics.headersUpload"
                       :on-progress="logisticsUploadStart"
                       :on-success="logisticsloaded" action="/products/import/logistics">
                <el-button slot="trigger" size="small" type="primary">Choisir un fichier</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!dialogLogistics.processing" @click="closeDialogLogistics()">Annuler</el-button>
                <el-button v-if="dialogLogistics.ended" @click="closeDialogLogistics()">Fermer</el-button>
                <el-button v-if="!dialogLogistics.processing" type="primary"
                           @click="closeDialogLogistics()">Confirmer</el-button>
            </span>
        </el-dialog>
        <el-dialog v-loading="dialogAccessories.loader" :fullscreen="true"
                   :visible.sync="dialogAccessories.display" title="Import Produits recommandées"
                   @close="closeDialogAccessories">
            <el-upload ref="uploadAccessories" :headers="dialogAccessories.headersUpload"
                       :on-progress="accessoriesUploadStart"
                       :on-success="accessoriesLoaded" action="/products/import/accessories">
                <el-button slot="trigger" size="small" type="primary">Choisir un fichier</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!dialogAccessories.processing" @click="closeDialogAccessories()">Annuler</el-button>
                <el-button v-if="dialogAccessories.ended" @click="closeDialogAccessories()">Fermer</el-button>
                <el-button v-if="!dialogAccessories.processing" type="primary" @click="closeDialogAccessories()">Confirmer</el-button>
            </span>
        </el-dialog>
        <el-dialog v-loading="dialogImportImages.loader" :fullscreen="true" :visible.sync="dialogImportImages.display"
                   title="Import photos" @close="closeDialogImportImages">
            <el-upload ref="uploadImportImages" :headers="dialogImportImages.headersUpload"
                       :on-error="importImagesError" :on-progress="importImagesUploadStart"
                       :on-success="importImagesUploaded" action="/products/import-images">
                <el-button slot="trigger" size="small" type="primary">Choisir un fichier</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!dialogImportImages.processing" @click="closeDialogImportImages()">Annuler</el-button>
                <el-button v-if="dialogImportImages.ended" @click="closeDialogImportImages()">Fermer</el-button>
                <el-button v-if="!dialogImportImages.processing" type="primary" @click="closeDialogImportImages()">Confirmer</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogSearch.display" title="Recherche par ref" @close="closeDialogSearch">
            <el-upload ref="uploadSearch" :action="'/products/uploadSearch/' + dialogSearch.form.type"
                       :headers="dialogSearch.headersUpload"
                       :on-progress="uploadSearchStart"
                       :on-success="searchUploaded">
                <el-button slot="trigger" size="small" type="primary">Choisir un fichier</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!dialogSearch.processing" @click="closeDialogSearch()">Annuler</el-button>
                <el-button v-if="dialogSearch.ended" @click="closeDialogSearch()">Fermer</el-button>
                <el-button v-if="!dialogSearch.processing" type="primary"
                           @click="closeDialogSearch()">Confirmer</el-button>
            </span>
        </el-dialog>
        <el-dialog v-loading="dialogVideos.loader" :fullscreen="true" :visible.sync="dialogVideos.display"
                   title="Import video" @close="closeDialogVideos">
            <el-upload ref="uploadVideos" :headers="dialogVideos.headersUpload" :on-progress="videosUploadStart"
                       :on-success="videosUploaded" action="/products/import/videos">
                <el-button slot="trigger" size="small" type="primary">Choisir un fichier</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!dialogVideos.processing" @click="closeDialogVideos()">Annuler</el-button>
                <el-button v-if="dialogVideos.ended" @click="closeDialogVideos()">Fermer</el-button>
                <el-button v-if="!dialogVideos.processing" type="primary"
                           @click="closeDialogVideos()">Confirmer</el-button>
            </span>
        </el-dialog>
        <component :is="actionComponent" v-if="actionComponent" ref="actionComponent"
                   :applyToAllResult="applyToAllResult"
                   :filters="filters" :items_selected="items_selected" :selected="selected" :total_item="total_item"
                   @saved="saved"></component>
    </div>
</template>
<script>
import { EventBus } from '../../event-bus';
import Product from '../../models/Product';
import searchParser from '../../utils/searchParser';
import { filterCascader } from '../filters';
//import RequestManager from '../../utils/requestManager';


export default {
    data() {
        return {
            syncErrorOptions: [],
            brandsOptions: [],
            categoriesOptions: [],
            manufacturersOptions: [],
            productTypeOptions: [],
            featuresOptions: [],
            sizesOptions: [],
            referencementSpeedwayOptions: [],
            loaderProductTypeOptions: false,
            loaderFeatures: false,
            loaderSizes: false,
            dialogSearch: {
                processing: false,
                loader: false,
                display: false,
                headersUpload: {
                    'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
                },
                form: {
                    type: null
                }
            },
            dialogSpin: {
                processing: false,
                loader: false,
                path: null,
                display: false,
                total: 0,
                pageSize: 10,
                currentPage: 1,
                currentRows: [],
                rows: [],
                headersUpload: {
                    'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
                }
            },
            dialogImport: {
                processing: false,
                loader: false,
                path: null,
                display: false,
                headersUpload: {
                    'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
                }
            },
            dialogPrices: {
                processing: false,
                loader: false,
                path: null,
                display: false,
                headersUpload: {
                    'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
                }
            },
            dialogEan: {
                processing: false,
                loader: false,
                path: null,
                display: false,
                headersUpload: {
                    'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
                }
            },
            dialogCoef: {
                processing: false,
                loader: false,
                path: null,
                display: false,
                headersUpload: {
                    'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
                }
            },
            dialogLogistics: {
                processing: false,
                loader: false,
                path: null,
                display: false,
                headersUpload: {
                    'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
                }
            },
            dialogAccessories: {
                processing: false,
                loader: false,
                path: null,
                display: false,
                headersUpload: {
                    'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
                }
            },
            dialogDatesDispos: {
                processing: false,
                loader: false,
                path: null,
                display: false,
                headersUpload: {
                    'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
                }
            },
            dialogImportImages: {
                processing: false,
                loader: false,
                path: null,
                display: false,
                headersUpload: {
                    'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
                }
            },
            dialogVideos: {
                processing: false,
                loader: false,
                path: null,
                display: false,
                headersUpload: {
                    'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
                },
            },
            dialogVideos: {
                processing: false,
                loader: false,
                path: null,
                display: false,
                headersUpload: {
                    'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
                }
            },
            prefixesOptions: [],
            sizeToggleFilter: 'mini',
            viewAllFilters: true,
            actionComponent: null,
            filters: {
                brand_id: '',
                manufacturer_id: '',
                category_id: [],
                category_exclude_id: [],
                queryAutocomplete: null,
                hasMedias: null,
                hasVariations: null,
                hasPrice: null,
                hasPaht: null,
                hasDesc: null,
                hasEan13: null,
                hasSeo: null,
                variationUndefined: null,
                activated: null,
                stock: null,
                duplicateShopId: null,
                duplicateRef: null,
                duplicate: null,
                priceValue: [],
                margeValue: [],
                mf_prefixe: null,
                isHybrid: null,
                created_at: null,
                isSync: null,
                syncError: null,
                syncPutStatus: null,
                variationShopId: null,
                deleted: false,
                fileSearch: null,
                fileSearchType: null,
                productType: null,
                features: null,
                features_exclude: null,
                hasDateDisposFourn: null,
                shop_ids: null,
                ids: null,
                external_refs: null,
                base_refs: null,
                ean13s: null,
                q: null,
                presta_activated: null,
                presta_stock: null,
                sync_stock: null,
                hasAccessories: null,
                referencement_speedway: [],
                hasNewPrice: null,
                hasVideo: null
            },
            pickerCreatedAt: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [
                    {
                        text: 'Aujourd\'hui',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    },
                    {
                        text: 'Hier',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: 'Il y a une semaine',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: 'Il y a un mois',
                        onClick(picker) {
                            const date = new Date();
                            date.setMonth(date.getMonth() - 1);
                            picker.$emit('pick', date);
                        }
                    }
                ]
            },
            groupedActionsOptions: [
                {
                    label: 'Changer le prix',
                    value: 'change_price'
                },
                {
                    label: 'Changer le SEO / Desc',
                    value: 'change_seo'
                },
                {
                    label: 'Permalink',
                    value: 'generate_permalink'
                },
                {
                    label: 'Supprimer les variations',
                    value: 'force_delete_variations'
                },
                {
                    label: 'Changer la photo',
                    value: 'change_photo'
                },
                {
                    label: 'Changer préfixe / fournisseur',
                    value: 'change_prefix'
                },
                {
                    label: 'Youtube',
                    value: 'youtube'
                },
                {
                    label: 'Changer la catégorie',
                    value: 'change_cat'
                },
                {
                    label: 'Changer la marque',
                    value: 'change_brand'
                },
                {
                    label: 'Changer la taille',
                    value: 'change_size'
                },
                {
                    label: 'Boost Produits',
                    value: 'boost'
                },
                {
                    label: 'Activer / Désactiver',
                    value: 'activate_desactivate'
                },
                {
                    label: 'Ajouter une feature',
                    value: 'product_type'
                },
                {
                    label: 'Regrouper en variations',
                    value: 'declinaison'
                },
                {
                    label: 'Regroupement de produit',
                    value: 'group_product'
                },
                {
                    label: 'Ajouts produits recommandés',
                    value: 'accessory'
                },
                {
                    label: 'Commentaires',
                    value: 'comment'
                },
                {
                    label: 'Hybrider le produit',
                    value: 'hybrid'
                },
                {
                    label: 'Désactivé syncro de stock',
                    value: 'desactivate_stock'
                },
                {
                    label: 'Supprimer photos',
                    value: 'remove_images'
                },
                {
                    label: 'Supprimer du PIM',
                    value: 'remove_pim'
                },
                {
                    label: 'Restaurer du PIM',
                    value: 'restore_pim'
                },
                {
                    label: 'Envoyer les prix',
                    value: 'send_prices'
                },
                {
                    label: 'Envoyer en review',
                    value: 'synchronize'
                },
                {
                    label: '[Comarch] Envoyer en review',
                    value: 'comarch'
                }
            ],
            groupedActionsValue: '',
            modal: {},
            abordController: null
        };
    },
    props: {
        selected: {
            default() {
                return [];
            }
        },
        view: {
            default: 'normal'
        }
    },
    computed: {
        q: {
            get() {
                return this.$store.getters['app/q'];
            },
            set(value) {
                this.filters.q = value;
                this.$store.dispatch('app/setQ', value);
            }
        },
        total_item() {
            return this.$store.getters['products/totalItems'];
        },
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
        applyToAllResult: {
            get() {
                return this.$store.getters['products/applyToAllResults'];
            },
            set(value) {
                this.$store.dispatch('products/setApplyToAllResults', value);
            }
        },
        duplicateMode() {
            return this.filters.duplicate || this.filters.duplicateRef;
        },
        user() {
            return this.$store.getters['app/user'];
        },
        products() {
            return this.$store.getters['products/items'];
        }
    },
    mounted() {
        axios.get('/productconstants').then(r => {
            this.syncErrorOptions = r.data.data;
        });
        axios.get('/products-variations/referencement').then(r => {
            this.referencementSpeedwayOptions = r.data.data;
        });
        axios.get('/brands').then(r => {
            this.brandsOptions = r.data.data;
        });
        axios.get('/categories').then(r => {
            this.categoriesOptions = r.data.data;
        });
        axios.get('/manufacturers').then(r => {
            this.manufacturersOptions = r.data.data;
        });
        this.loaderProductTypeOptions = true;
        axios.get('/filters/features/typesProduct?orderBy=value&order=asc').then(r => {
            this.productTypeOptions = r.data.data;
        }).then(() => {
            this.loaderProductTypeOptions = false;
        });
        this.loaderFeatures = true;
        axios.get('/features?mode=list&cascader=1&limit=-1').then(r => {
            this.featuresOptions = r.data.data;
        }).then(() => {
            this.loaderFeatures = false;
        });
        this.loaderSizes = true;
        axios.get('/variations/1/values?orderBy=value&order=asc&limit=500').then(r => {
            this.sizesOptions = r.data.data;
        }).then(() => {
            this.loaderSizes = false;
        });
        axios.get('/manufacturers/prefixes').then(r => {
            this.prefixesOptions = r.data.data;
        });
        this.$nextTick(() => {
            this.filters.q = this.q;
        });

        EventBus.$on('search-input.submit', () => {
            var parsed = searchParser(this.q);
            if (parsed && parsed.type != 'category') {
                this.filters[parsed.type + '_id'] = parseInt(parsed.value);
            }
            this.validFilters();
        });
        this.groupedActionsOptions = this.groupedActionsOptions.filter((v) => {
            return this.user.can('actions groupes ' + v.value);
        });
    },
    methods: {
        createProduct() {
            axios.post('/products').then(r => {

                var items = this.$store.getters['products/items'];
                items[0] = r.data.data;

                this.$store.dispatch('products/setItems', items);

                EventBus.$emit('products.list.edit', r.data.data);
            });
        },
        closeDialogSpin() {
            this.dialogSpin.rows = [];
            this.dialogSpin.total = 0;
            this.dialogSpin.path = null;
            this.dialogSpin.processing = false;
            this.dialogSpin.ended = false;
            this.dialogSpin.loader = false;
            this.dialogSpin.currentRows = [];
            this.$refs.uploadSpin.clearFiles();
        },
        pageSpinChange(page) {
            let index = (page * this.dialogSpin.pageSize) - 1;
            if (page == 1) {
                index = 0;
            }
            let indexEnd = index + this.dialogSpin.pageSize;
            this.dialogSpin.currentRows = this.dialogSpin.rows.slice(index, indexEnd);
        },
        spinUploaded(response, file, fileList) {
            this.dialogSpin.rows = response.data;
            this.dialogSpin.path = response.path;
            this.dialogSpin.total = this.dialogSpin.rows.length;
            this.dialogSpin.loader = false;
            this.pageSpinChange(1);
        },
        spinUploadStart(e, file, fileList) {
            this.dialogSpin.loader = true;
        },
        processSpin() {
            this.dialogSpin.processing = true;
            this.dialogSpin.loader = true;
            axios
                .post('/products/spinProduct', {
                    path: this.dialogSpin.path
                })
                .then(r => {
                    this.$message({
                        message: 'Produits mis à jour avec le Spin.',
                        type: 'success'
                    });

                })
                .catch(e => {
                })
                .then(() => {
                    this.dialogSpin.loader = false;
                    this.dialogSpin.ended = true;
                });
        },
        displayDialogSpin(action) {
            if (action == 'open') {
                this.dialogSpin.display = true;
            } else if (action == 'process') {
                this.dialogSpin.processing = true;
                this.processSpin();
            } else {
                this.dialogSpin.display = false;
            }
        },
        displayDialogSearch(type) {
            this.dialogSearch.display = true;
            this.dialogSearch.form.type = type;
        },
        closeDialogSearch() {
            this.dialogSearch.path = null;
            this.dialogSearch.processing = false;
            this.dialogSearch.ended = false;
            this.dialogSearch.loader = false;
            this.dialogSearch.display = false;
            this.$refs.uploadSearch.clearFiles();
        },
        uploadSearchStart(e, file, fileList) {
            this.dialogSearch.loader = true;
        },
        searchUploaded(response, file, fileList) {
            this.dialogSearch.loader = false;
            this.filters.fileSearch = response.path;
            this.filters.fileSearchType = response.type;
            this.closeDialogSearch();
            this.validFilters();
        },
        importUploaded(response, file, fileList) {
            this.dialogImport.loader = false;
            this.$notify.info({
                title: 'Info',
                message: response.message
            });
            this.closeDialogImport();
        },
        importUploadStart(e, file, fileList) {
            this.dialogImport.loader = true;
        },
        displayDialogImport() {
            this.dialogImport.display = true;
        },
        closeDialogImport() {
            this.dialogImport.path = null;
            this.dialogImport.processing = false;
            this.dialogImport.ended = false;
            this.dialogImport.loader = false;
            this.dialogImport.display = false;
            this.$refs.uploadImport.clearFiles();
        },
        pricesUploaded(response, file, fileList) {
            this.dialogPrices.loader = false;
            this.$notify.info({
                title: 'Info',
                message: response.message
            });
            this.closeDialogPrices();
        },
        pricesUploadStart(e, file, fileList) {
            this.dialogPrices.loader = true;
        },
        displayDialogPrices() {
            this.dialogPrices.display = true;
        },
        closeDialogPrices() {
            this.dialogPrices.path = null;
            this.dialogPrices.processing = false;
            this.dialogPrices.ended = false;
            this.dialogPrices.loader = false;
            this.dialogPrices.display = false;
            this.$refs.uploadPrices.clearFiles();
        },
        eanUploaded(response, file, fileList) {
            this.dialogEan.loader = false;
            this.$notify.info({
                title: 'Info',
                message: response.message
            });
            this.closeDialogEan();
        },
        eanUploadStart(e, file, fileList) {
            this.dialogEan.loader = true;
        },
        displayDialogEan() {
            this.dialogEan.display = true;
        },
        closeDialogEan() {
            this.dialogEan.path = null;
            this.dialogEan.processing = false;
            this.dialogEan.ended = false;
            this.dialogEan.loader = false;
            this.dialogEan.display = false;
            this.$refs.uploadEan.clearFiles();
        },
        videosUploaded(response, file, fileList) {
            this.dialogVideos.loader = false;
            this.$notify.info({
                title: 'Info',
                message: response.message
            });
            this.closeDialogVideos();
        },
        videosUploadStart(e, file, fileList) {
            this.dialogVideos.loader = true;
        },
        displayDialogVideos() {
            this.dialogVideos.display = true;
        },
        closeDialogVideos() {
            this.dialogVideos.path = null;
            this.dialogVideos.processing = false;
            this.dialogVideos.ended = false;
            this.dialogVideos.loader = false;
            this.dialogVideos.display = false;
            this.$refs.uploadVideos.clearFiles();
        },
        datesDisposUploaded(response, file, fileList) {
            this.dialogDatesDispos.loader = false;
            this.$notify.info({
                title: 'Info',
                message: response.message
            });
            this.closeDialogDatesDispos();
        },
        datesDisposUploadStart(e, file, fileList) {
            this.dialogDatesDispos.loader = true;
        },
        displayDialogDatesDispos() {
            this.dialogDatesDispos.display = true;
        },
        closeDialogDatesDispos() {
            this.dialogDatesDispos.path = null;
            this.dialogDatesDispos.processing = false;
            this.dialogDatesDispos.ended = false;
            this.dialogDatesDispos.loader = false;
            this.dialogDatesDispos.display = false;
            this.$refs.uploadDatesDispos.clearFiles();
        },
        coefUploaded(response, file, fileList) {
            this.dialogCoef.loader = false;
            this.$notify.info({
                title: 'Info',
                message: response.message
            });
            this.closeDialogCoef();
        },
        coefUploadStart(e, file, fileList) {
            this.dialogCoef.loader = true;
        },
        displayDialogCoef() {
            this.dialogCoef.display = true;
        },
        closeDialogCoef() {
            this.$refs.uploadCoef.clearFiles();
            this.dialogCoef.path = null;
            this.dialogCoef.processing = false;
            this.dialogCoef.ended = false;
            this.dialogCoef.loader = false;
            this.dialogCoef.display = false;

        },
        logisticsloaded(response, file, fileList) {
            this.dialogLogistics.loader = false;
            this.$notify.info({
                title: 'Info',
                message: response.message
            });
            this.closeDialogLogistics();
        },
        logisticsUploadStart(e, file, fileList) {
            this.dialogLogistics.loader = true;
        },
        displayDialogLogistics() {
            this.dialogLogistics.display = true;
        },
        closeDialogLogistics() {
            this.$refs.uploadLogistics.clearFiles();
            this.dialogLogistics.path = null;
            this.dialogLogistics.processing = false;
            this.dialogLogistics.ended = false;
            this.dialogLogistics.loader = false;
            this.dialogLogistics.display = false;

        },
        accessoriesLoaded(response, file, fileList) {
            this.dialogAccessories.loader = false;
            this.$notify.info({
                title: 'Info',
                message: response.message
            });
            this.closeDialogAccessories();
        },
        accessoriesUploadStart(e, file, fileList) {
            this.dialogAccessories.loader = true;
        },
        displayDialogAccessories() {
            this.dialogAccessories.display = true;
        },
        closeDialogAccessories() {
            this.$refs.uploadAccessories.clearFiles();
            this.dialogAccessories.path = null;
            this.dialogAccessories.processing = false;
            this.dialogAccessories.ended = false;
            this.dialogAccessories.loader = false;
            this.dialogAccessories.display = false;

        },
        importImagesUploaded(response, file, fileList) {
            this.dialogImportImages.loader = false;
            this.$notify.info({
                title: 'Info',
                message: response.message
            });
            this.closeDialogImportImages();
        },
        importImagesError(response, file, fileList) {
            this.dialogImportImages.loader = false;
            let json = JSON.parse(response.message);
            this.$notify.error({
                title: 'Erreur',
                message: json.message,
                duration: 10000
            });
            this.closeDialogImportImages();
        },
        importImagesUploadStart(e, file, fileList) {
            this.dialogImportImages.loader = true;
        },
        displayDialogImportImages() {
            this.dialogImportImages.display = true;
        },
        closeDialogImportImages() {
            this.dialogImportImages.path = null;
            this.dialogImportImages.processing = false;
            this.dialogImportImages.ended = false;
            this.dialogImportImages.loader = false;
            this.dialogImportImages.display = false;
            this.$refs.uploadImportImages.clearFiles();
        },
        resetFilters() {
            this.$refs.filtersForm.resetFields();
            this.$store.dispatch('app/setQ', null);
            this.filters.product_id = null;
            this.validFilters();
        },

        handleDuplicateRef(v) {
            if (v) {
                this.$refs.filtersForm.resetFields();
                this.$store.dispatch('app/setQ', null);
                this.filters.product_id = null;
                this.filters.duplicate = true;
            }
        },

        handleChangeFilter(v) {
            /*
            if( this.filters.duplicateRef ) {
                this.filters.duplicateRef = null
            }
            */
        },

        validFilters() {
            var filters = {};
            this.filters.q = this.q;
            var exclude = ['applyToAllResult'];
            for (let filter in this.filters) {
                var value = this.filters[filter];
                if (exclude.indexOf(filter) == -1) {
                    switch (typeof value) {
                        case 'object':
                            if (value !== null && value.length) {
                                filters[filter] = value;
                            }
                            break;

                        default:
                            if (value !== null && value !== '') {
                                filters[filter] = value;
                            }
                            break;
                    }
                }
            }
            this.$emit('update-filters', filters);
        },
        setFilter(filter_name, value, noValidate) {
            this.filters[filter_name] = value;
            if (!noValidate) {
                this.validFilters();
            }
        },
        saved(r) {
            this.callbackAction(r);
        },
        applyAction(v) {
            if (!this.selected.length && !this.applyToAllResult) return;
            this.$store.dispatch('products/setLoader', true);
            this.actionComponent = require('./actions/' + v).default;
            this.$nextTick(function() {
                let firstProduct = this.applyToAllResult ? this.products[0] : this.selected[0];
                this.$refs.actionComponent.open(firstProduct);
            });
        },
        callbackAction(r) {
            if (r.data.job) {
                this.$notify.info({
                    title: 'Info',
                    message: r.data.message
                });
            } else {
                this.$emit('productsUpdated', Product.build(r.data.data));
            }
            this.applyToAllResult = false;
        },
        exportProducts(type) {
            let params = Object.assign({}, this.filters);
            if (this.q) {
                params.q = this.q;
            }
            params.type = type;
            axios
                .post('/products/export', { params })
                .then(r => {
                    this.callbackAction(r);
                })
                .catch(() => {
                })
                .then(() => {
                });
        },
        filterCascader(node, keyword) {
            return filterCascader(node, keyword);
        },
        testAbord() {
            /*const requestManager = new RequestManager()


            axios.get('/catalog', {
                signal: requestManager.getSignalAndKillOther('test')
            }).then(r => {
                console.log(r)
            }).catch(e => {
                console.log(e)
            })*/
        }
    }
};
</script>
<style lang="scss">
.el-table .error-variation-already {
    td {
        background: #fb8e8d !important;
        color: #fff;
    }
}

.el-table .warning-variation-already {
    td {
        background: #fbd48d !important;
    }
}

.toggle-filters {
    .el-switch__label * {
        font-size: 12px;
    }
}

.el-form {
    .card-footer {
        text-align: initial;

        .pull-right {
            text-align: center;
        }
    }
}

.ctn-limit-height {
    height: 70vh;
    overflow-y: auto;
    overflow-x: hidden;
}

.hasSelected {
    .el-collapse-item__header {
        color: #409eff;
        font-weight: bold;
    }
}
</style>
